module.exports = __webpack_public_path__ + "img/iqf-jiechuqiyejiang.5a7d69df.png";